import { useEffect, useState } from 'react';
import supabase from 'modules/core/supabase/supabase';

function useConnectionIndicator() {
  const [isJoystickActive, setIsJoystickActive] = useState(true);
  const [ethernetConnection, setEthernetConnection] = useState(true);
  const [connectionStatus, setConnectionStatus] = useState(supabase.matchChronology.connectionStatus.value);

  useEffect(() => {
    const unsubscribe = supabase.matchChronology.connectionStatus.subscribe((data) => {
      setConnectionStatus(data);
    });
    // Статус мог смениться между первым рендером и подпиской.
    setConnectionStatus(supabase.matchChronology.connectionStatus.value);

    const activeEthernet = () => {
      setEthernetConnection(true);
      console.debug({ event: 'internet connection recovered' });
    };
    const disableEthernet = () => {
      setEthernetConnection(false);
      console.error({ event: 'internet connection lost' });
    };

    window.addEventListener('online', activeEthernet);
    window.addEventListener('offline', disableEthernet);
    return () => {
      unsubscribe();
      window.removeEventListener('online', activeEthernet);
      window.removeEventListener('offline', disableEthernet);
    };
  }, []);

  useEffect(() => {
    if (connectionStatus === 'SUBSCRIBED' && ethernetConnection) {
      setIsJoystickActive(true);
    } else {
      setIsJoystickActive(false);
    }
  }, [connectionStatus, ethernetConnection]);

  return { isJoystickActive };
}

export default useConnectionIndicator;
